/** Normalize phone_number_id for comparisons and socket payloads. */
export function normalizePhoneId(id) {
  return String(id ?? "").trim();
}

/** Normalize customer WA id for comparisons. */
export function normalizeCustomerPhone(phone) {
  return String(phone ?? "").trim();
}

export function phonesMatch(a, b) {
  return normalizePhoneId(a) === normalizePhoneId(b);
}

export function customersMatch(a, b) {
  const digits = (p) => normalizeCustomerPhone(p).replace(/\D/g, "");
  const na = digits(a);
  const nb = digits(b);
  return na.length > 0 && na === nb;
}
